import QRCode from 'react-qr-code';
import { Modal } from './Modal';
import { useQRCode } from '../../context/QRCodeContext';
import './QRCodeModal.css';

export const QRCodeModal = () => {
  const { isOpen, closeQRCodeModal } = useQRCode();
  const url = 'https://chain-play.netlify.app';

  return (
    <Modal isOpen={isOpen} onClose={closeQRCodeModal} className="qrcode-modal">
      <div className="qrcode-modal__wrapper">
        <QRCode
          value={url}
          size={280}
          className="qrcode-modal__svg"
          fgColor="#000000"
          bgColor="transparent"
        />
      </div>
    </Modal>
  );
};
